"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styles = require("./styles");
var _excluded = ["route", "params", "queryParams", "store", "refresh", "onClickReaction", "onClick", "shouldScrollBeRestored", "dataCy", "children", "title"];
/**
 * Forked component from mobx-react <Link />
 * https://github.com/kitze/mobx-router/blob/master/src/components/Link.js
 * - Added onClickReaction ability
 * - Added shouldScrollBeRestored ability
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var LinkBase = function LinkBase(_ref) {
  var route = _ref.route,
    _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params,
    _ref$queryParams = _ref.queryParams,
    queryParams = _ref$queryParams === void 0 ? {} : _ref$queryParams,
    store = _ref.store,
    _ref$refresh = _ref.refresh,
    refresh = _ref$refresh === void 0 ? false : _ref$refresh,
    onClickReaction = _ref.onClickReaction,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? onClickReaction : _ref$onClick,
    _ref$shouldScrollBeRe = _ref.shouldScrollBeRestored,
    shouldScrollBeRestored = _ref$shouldScrollBeRe === void 0 ? false : _ref$shouldScrollBeRe,
    dataCy = _ref.dataCy,
    children = _ref.children,
    title = _ref.title,
    forwardedProps = _objectWithoutProperties(_ref, _excluded);
  var router = store.router;
  if (!router) {
    console.error('The router prop must be defined for a Link component to work!');
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_styles.UnstyledLink, _extends({
    "data-cy": dataCy
  }, forwardedProps, {
    onClick: function onClick(e) {
      var middleClick = e.button === 2;
      var cmdOrCtrl = e.metaKey || e.ctrlKey;
      var openinNewTab = middleClick || cmdOrCtrl;
      var shouldNavigateManually = refresh || openinNewTab || cmdOrCtrl;
      if (shouldNavigateManually) {
        if (typeof _onClick === 'function') {
          _onClick();
        }
        return;
      }
      e.preventDefault();
      var linkAction = function linkAction() {
        if (store !== null && store !== void 0 && store.ui) {
          store.ui.shouldScrollBeRestoredForNextRoute = shouldScrollBeRestored;
        }
        router.goTo(route, params, queryParams);
        if (typeof _onClick === 'function') {
          _onClick();
        }
      };
      if (store !== null && store !== void 0 && store.unsavedChangesDialog) {
        return store.unsavedChangesDialog.check().then(linkAction);
      }
      linkAction();
    },
    href: route.replaceUrlParams(params, queryParams)
  }), title || children);
};
var _default = exports["default"] = (0, _mobxReact.observer)(LinkBase);
//# sourceMappingURL=index.js.map